// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label{font-size:10px;text-transform:uppercase;color:rgba(22,27,37,.4);display:block}.label__subtext{display:block;font-size:11px;line-height:1.5;margin-top:4px}", ""]);
// Exports
module.exports = exports;
